export default process.env.REACT_APP_ENABLE_REDUX_LOGGING === 'true';
